// src/admin/components/StatusBadge.jsx
export function StatusBadge({
  status,
  active,
  activeLabel = "Actif",
  inactiveLabel = "Suspendu",
}) {
  // =========================
  // MODE COMMANDES
  // =========================
  if (status) {
    const map = {
      en_attente: ["bg-yellow-100 text-yellow-800", "En attente"],
      en_preparation: ["bg-blue-100 text-blue-800", "Préparation"],
      prete: ["bg-indigo-100 text-indigo-800", "Prête"],
      livree: ["bg-green-100 text-green-700", "Livrée"],
      annulee: ["bg-gray-200 text-gray-700", "Annulée"],
      critique: ["bg-red-200 text-red-900", "Critique"],
    };

    const [cls, label] =
      map[status] || ["bg-gray-100 text-gray-700", status.replace("_", " ")];

    return (
      <span
        className={`inline-flex items-center px-3 py-1 text-xs font-bold rounded-full ${cls}`}
      >
        {label}
      </span>
    );
  }

  // =========================
  // MODE ACTIF / SUSPENDU
  // =========================
  return (
    <span
      className={`inline-flex items-center px-3 py-1 text-xs font-bold rounded-full ${
        active
          ? "bg-green-100 text-green-700"
          : "bg-red-100 text-red-700"
      }`}
    >
      {active ? activeLabel : inactiveLabel}
    </span>
  );
}